import axios from "axios";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const COMPANY = {
  name: "NOUROZI EBYGG & ANLEGG",
  phone: "939 35 111",
  phoneClean: "+4793935111",
  email: "ehsannourzi021@gmail.com",
  area: "Halden og omegn",
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",
};

export const SERVICE_OPTIONS = [
  "Tømrerarbeid","Oppussing","Kjøkkenmontering","Terrasse","Tak","Kledning","Dører/vinduer","Belegningsstein","Graving","Tilbygg","Annet"
];

export const PROJECT_CATEGORIES = ["Alle","Terrasse","Kjøkken","Tak","Kledning","Oppussing","Belegningsstein","Graving","Tilbygg","Dører/Vinduer","Tømrer"];

export const STATUS_META = {
  new: { label: "Nye forespørsler", color: "#2563EB" },
  contacted: { label: "Kontaktet", color: "#D97706" },
  inspection: { label: "Befaring", color: "#7C3AED" },
  quote_sent: { label: "Tilbud sendt", color: "#059669" },
  won: { label: "Vunnet", color: "#16A34A" },
  lost: { label: "Tapt", color: "#9CA3AF" },
  archived: { label: "Arkivert", color: "#6B7280" },
};

// Resolve image URL from a doc with either image_id (uploaded) or image_url (external)
export function imgUrl(doc, idField = "image_id", urlField = "image_url") {
  if (!doc) return "";
  if (doc[idField]) return `${process.env.REACT_APP_BACKEND_URL}/api/files/${doc[idField]}`;
  return doc[urlField] || "";
}

export function projectCover(p) {
  if (p?.cover_image_id) return `${process.env.REACT_APP_BACKEND_URL}/api/files/${p.cover_image_id}`;
  return p?.cover_image_url || "";
}
